import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CategoryDto } from '@cradua/data';
import Swal from 'sweetalert2';


@Component({
  selector: 'cradua-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.scss']
})
export class CategoryComponent implements OnChanges {


  categoryForm: FormGroup;
  categoryFormArray: FormGroup;
  control = new FormControl();
  @Input() categorys: CategoryDto[];
  @Input() routeAnimationsElements: any;
  @Output() category = new EventEmitter<CategoryDto[]>()
  @Output() deleteCategoryEvent = new EventEmitter<any>()

    selectedCategory: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    constructor(
     private fb: FormBuilder,
     ) {}

    ngOnChanges() {
      this.createCategoryForm();
    }

    createCategoryForm() {
      this.categoryForm = this.fb.group({
        CategoryName: ['', Validators.required],
        id: null
        });
        this.categoryFormArray = this.fb.group({ Categorys: this.fb.array([])
          });
        this.setCategory();
    }

  // method to display categorys
  setCategory() {
    const control  = this.categoryFormArray.controls.Categorys as FormArray;
    this.categorys.forEach( e => {
      control.push(
        this.fb.group({
          CategoryName: e.CategoryName,
          id: e.id
        })
      );
    });
  }


  // method to add Category
  addCategory(value: CategoryDto) {
    const control  = this.categoryFormArray.controls.Categorys as FormArray;
    control.insert(0,
          this.fb.group({
            CategoryName: value.CategoryName,
            id: null
          })
       );
  }

  selectCategory(value) {}

  // method to delete category from arrary list
  deleteCategory(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.categoryFormArray.controls.Categorys as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.categorys.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.categorys[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: CategoryDto) {
    if(this.categoryForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.categoryFormArray.get('Categorys')['controls'][this.selectedIndex].patchValue({CategoryName: formValue.CategoryName});
    } else {
      this.addCategory(formValue);
    }
    this.selectedIndex = null;
    this.categoryForm.reset()
  }

  onEdit(index, value: CategoryDto) {
    console.log(index, value)
    this.selectedIndex = index;
    this.categoryForm.patchValue({CategoryName: value.CategoryName});
  }

  onClearForm() {
    this.selectedIndex = null;
    this.categoryForm.reset();
  }

  onSubmit(formValue: CategoryDto[]) {
  this.category.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deleteCategoryEvent.emit(this.filteredDelete);
  }
  }

}
